import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { InputSlots, Keypad } from './DigitKeypad';

export function numericAnswerLength(round, question) {
  if (question?.answer_mode === 'numeric_entry' && Number.isInteger(question.answer_length) && question.answer_length >= 1 && question.answer_length <= 12) return question.answer_length;
  if (!round?.preview || !/^curriculum_math_[2-8]$/.test(round?.skill_key || '')) return null;
  const match = /^(?:Boşluğu tamamla:|Örüntüyü tamamla:)\s*([0-9?\s-]+)$/.exec(question?.prompt || '');
  const answer = String(question?.correct_answer ?? '');
  return match && (match[1].match(/\?/g) || []).length === 1 && /^[0-9]{1,8}$/.test(answer) ? answer.length : null;
}

export default function NumericAnswerInput({ length, disabled, qaMode, correctAnswer, onAnswer }) {
  const [value, setValue] = useState('');
  const sent = useRef(false);
  const locked = disabled || qaMode;
  const add = (digit) => { if (!locked) setValue((current) => current.length < length ? current + digit : current); };
  const remove = () => { if (!locked) setValue((current) => current.slice(0, -1)); };
  const submit = () => {
    if (locked || value.length !== length || sent.current) return;
    sent.current = true;
    onAnswer(value);
  };
  useEffect(() => {
    if (!disabled) sent.current = false;
  }, [disabled]);
  useEffect(() => {
    const handle = (event) => {
      if (locked || event.ctrlKey || event.metaKey || event.altKey || /INPUT|TEXTAREA/.test(event.target?.tagName || '') || event.target?.isContentEditable) return;
      if (/^[0-9]$/.test(event.key)) { event.preventDefault(); add(event.key); }
      else if (event.key === 'Backspace') { event.preventDefault(); remove(); }
      else if (event.key === 'Enter' && !/BUTTON/.test(event.target?.tagName || '')) { event.preventDefault(); submit(); }
    };
    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  });
  return <Box sx={{ width: '100%', my: 1 }}>
    <Typography sx={{ textAlign: 'center', fontWeight: 800, color: '#4c1d95', mb: 1 }}>{qaMode ? 'Doğru cevap' : 'Cevabını yaz'}</Typography>
    <InputSlots length={length} value={qaMode ? String(correctAnswer ?? '') : value} />
    <Keypad disabled={locked} onDigit={add} onDelete={remove} onSubmit={submit} submitDisabled={value.length !== length} submitLabel="Kontrol et" />
  </Box>;
}
